import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './PageTitle.css'


var PageTitle = BaseView.extend({
    playIn(options) {
        this.$el.velocity('stop', true)

        return $.Velocity.animate(this.$el[0], {opacity: 1}, _.extend({
            duration: 1500,
            display: 'block',
            easing: 'ease-in'
        }, options))
    },

    playOut(options) {
        this.$el.velocity('stop', true)

        return $.Velocity.animate(this.$el[0], {opacity: 0}, _.extend({
            duration: 1500,
            display: 'none',
            easing: 'ease-in'
        }, options))
    }
})

export default PageTitle


// WEBPACK FOOTER //
// ./assets/app/front/components/PageTitle/PageTitle.js